import firebase from "firebase";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Text } from "react-native";
import { StyleSheet } from "react-native";
import { Dimensions } from "react-native";
import { View } from "react-native";
import { RFValue } from "react-native-responsive-fontsize";
import CustomHeader from "../../components/CustomHeader";
import MenuIcon from "../../components/icons/MenuIcon";
import { home } from "../../constants/dataset";
import getRevenue from "../../networking/api/stats/getRevenue";
import getUsersCount from "../../networking/api/stats/getUsersCount";
import state from "../../store/Store";
import useEffectAsync from "../../functions/useEffectAsync";
import getWeather from "../../networking/api/weather/getWeather";
import { ActivityIndicator } from "react-native";
import { Image } from "react-native";
import { ImageBackground } from "react-native";
import mapAssets from "../../functions/mapAssets";
import * as Animatable from "react-native-animatable";

const { height, width } = Dimensions.get("window");

const Home = observer(({ navigation }) => {
  const [weather, setWeather] = useState();
  const [loading, setLoading] = useState(false);
  const { usersCount, revenue, ordersCount, uniqueUsersCount } = state;

  useEffect(() => {
    getUsersCount();
    getRevenue();
    return () => null;
  }, []);

  useEffectAsync(async () => {
    await getWeather(
      (e) => setLoading(e),
      (e) => setWeather(e)
    );
  }, []);

  useEffect(() => {
    setInterval(
      async () =>
        await getWeather(
          (e) => setLoading(e),
          (e) => setWeather(e)
        ),
      60000 * 120
    );
  }, []);

  const { main, temp, city, updatedAt } = weather || {};

  let data = home(usersCount, ordersCount, uniqueUsersCount, revenue);

  return (
    <ImageBackground style={styles.container} source={mapAssets[main]} imageStyle={styles.containerImage}>
      <CustomHeader title="Home" leftIcon={<MenuIcon navigation={navigation} />} />
      <View style={styles.rowView}>
        {data.map((o, i) => (
          <View key={o + i.toString()} style={[styles.box, { backgroundColor: o.color }]}>
            <Text style={styles.numberText}>{o.value}</Text>
            <Text style={styles.attrText}>{o.label}</Text>
          </View>
        ))}
      </View>
      <View style={styles.weatherView}>
        {loading ? (
          <ActivityIndicator animating size="large" color="white" />
        ) : (
          <View style={styles.center}>
            <Text style={styles.city}>{city}</Text>
            <Text style={styles.temp}>{temp}</Text>
            <Text style={styles.main}>{main}</Text>
            <Text style={styles.main}>{"Last updated at " + updatedAt}</Text>
          </View>
        )}
      </View>
    </ImageBackground>
  );
});

export default Home;

const styles = StyleSheet.create({
  center: { alignItems: "center" },
  main: {
    fontFamily: "avenir",
    fontSize: RFValue(14),
    color: "white",
  },
  temp: {
    fontFamily: "avenir-h",
    fontSize: RFValue(25),
    color: "orange",
  },
  city: {
    fontFamily: "avenir-h",
    fontSize: RFValue(25),
    color: "white",
  },
  weatherView: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: height * 0.05,
  },
  containerImage: { flex: 1, aspectRatio: 1 },
  container: { flex: 1, backgroundColor: "#fff" },
  rowView: {
    marginHorizontal: 5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  attrText: {
    fontFamily: "avenir-h",
    fontSize: RFValue(10),
    color: "white",
  },
  numberText: {
    fontFamily: "avenir-h",
    fontSize: RFValue(20),
    color: "white",
  },
  box: {
    shadowOpacity: 1,
    shadowRadius: 5,
    shadowColor: "black",
    shadowOffset: { width: 10, height: 10 },
    width: width * 0.2,
    borderRadius: 10,
    margin: 5,
    height: height * 0.2,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
});
